// extracted by mini-css-extract-plugin
export default {"footer":"ModalDeliveryNote_footer__-rKFh","flexAlignEnd":"ModalDeliveryNote_flexAlignEnd__QWpO8"};